import { render, staticRenderFns } from "./table.onboarding-dashboard.vue?vue&type=template&id=4b333e61&scoped=true&"
import script from "./table.onboarding-dashboard.vue?vue&type=script&lang=js&"
export * from "./table.onboarding-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./table.onboarding-dashboard.vue?vue&type=style&index=0&id=4b333e61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b333e61",
  null
  
)

export default component.exports